import { Directive, Input, OnChanges, inject } from '@angular/core';
import { ButtonComponent } from './button.component';

type Selector = 'dashboard' | 'secondary' | 'danger' | 'neutral' | 'small' | 'borderless';

@Directive({
  selector:
    'app-button[dashboard], app-button[secondary], app-button[danger], app-button[neutral], app-button[small], app-button[borderless]',
  standalone: true,
})
export class ButtonDirective implements OnChanges {
  @Input() borderless: boolean | '' | undefined;
  @Input() danger: boolean | '' | undefined;
  @Input() dashboard: boolean | '' | undefined;
  @Input() neutral: boolean | '' | undefined;
  @Input() secondary: boolean | '' | undefined;
  @Input() small: boolean | '' | undefined;

  private _component = inject(ButtonComponent, { host: true });

  ngOnChanges(): void {
    this._component.classes.set({
      ...this._component.classes(),
      editor: !this._hasStyle('dashboard'),
      dashboard: this._hasStyle('dashboard'),
      primary: !this._hasStyle('secondary'),
      secondary: this._hasStyle('secondary'),
      danger: this._hasStyle('danger'),
      neutral: this._hasStyle('neutral'),
      small: this._hasStyle('small'),
      borderless: this._hasStyle('borderless'),
    });
  }

  private _hasStyle = (selector: Selector): boolean => this[selector] === '' || !!this[selector];
}
